import {
  Component,
  OnInit,
  Input,
  OnChanges,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
} from "@angular/core";

import { EditGroupModalComponent } from "../edit-group-modal/edit-group-modal.component";
import { GroupComponent } from "../group/group.component";
import { MatDialog } from "@angular/material/dialog";

import { GroupingService } from "../../grouping/grouping.service";
import { DashboardDisplayService } from "../../dashboardDisplay/dashboardDisplay.service";
import { environment } from "../../../environments/environment";

import * as _ from "lodash";

@Component({
  selector: "grouping-body",
  templateUrl: "./grouping-body.component.html",
  styleUrls: ["./grouping-body.component.scss"],
})
export class GroupingBodyComponent implements OnInit, OnChanges {
  @Input()
  selectedDataConfig;

  @Output() visibilityChanged = new EventEmitter();

  @Output() goToCurrentGradeLevelEmitter = new EventEmitter();

  @ViewChildren("myGroups") groups: QueryList<any>;

  customerGroupings;
  codesSelected;
  originalCustomerGroupings;
  areChangesToBeSaved;
  saveInProgress;
  groupingTemplateId;
  loadingData;
  saveError;
  hostname = `${environment.szAppHostname}`;
  definition;
  truncatedDefinition;

  constructor(
    public groupingService: GroupingService,
    public dashboardDisplayService: DashboardDisplayService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {}

  ngOnChanges(change) {
    this.loadingData = true;
    if (change.selectedDataConfig && this.selectedDataConfig) {
      this.codesSelected = null;
      this.areChangesToBeSaved = null;
      this.customerGroupings = null;
      let templateId;
      if (this.selectedDataConfig.groupingTemplateId) {
        templateId = this.selectedDataConfig.groupingTemplateId;
      } else {
        templateId = this.selectedDataConfig.grouping_template_id;
      }
      this.groupingTemplateId = templateId;
      if (templateId) {
        this.groupingService
          .getCustomerGroupingByTemplateId(templateId)
          .subscribe(
            (data) => {
              this.customerGroupings = data;
              this.definition =
                this.customerGroupings.name +
                " " +
                this.customerGroupings.fieldMappingDefinition;
              if (
                this.customerGroupings &&
                this.customerGroupings.fieldMappingDefinition &&
                this.customerGroupings.fieldMappingDefinition.length > 180
              ) {
                this.truncatedDefinition =
                  this.definition.substring(0, 180) + "...";
              } else {
                this.truncatedDefinition = null;
              }
              this.sortCustomerData();
              this.originalCustomerGroupings = _.cloneDeep(
                this.customerGroupings
              );
              this.loadingData = false;
              this.groupingService.hideError();
            },
            (error) => {
              console.log(error);
              if (templateId == 10) {
                //Custom error message for the 'District-Created Benchmark' group
                this.groupingService.showError(
                  "This configuration is only available if you have the Course Failures " +
                    "by Grading Period metric. It is not available for the Course Failures by Term metric. " +
                    "If you expect to be able to configure grade period values, please <a " +
                    'href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395" ' +
                    'target=\'_blank\' title="Support" class="support-link">contact support</a>.'
                );
              } else if (templateId == 11) {
                //Custom error message for the 'District-Created Benchmark' group
                this.groupingService.showError(
                  "This configuration is only available for the illuminate_test connector. " +
                    "If you expect to be able to map test type values for Illuminate, please " +
                    '<a href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395" ' +
                    'target=\'_blank\' title="Support" class="support-link">contact support</a>.'
                );
              } else if (error == 413) {
                //Custom error message for if there are too many results.
                this.groupingService.showError(
                  "There are too many results to display. If you need assistance, please " +
                    '<a href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395" ' +
                    'target=\'_blank\' title="Support" class="support-link">contact support</a>.'
                );
              } else {
                this.groupingService.showError();
              }
            }
          );
      } else {
        this.customerGroupings = null;
        this.originalCustomerGroupings = null;
        this.loadingData = false;
        this.groupingService.hideError();
      }
    }
  }

  sortCustomerData() {
    // first check if this is a sortable grouping
    if (this.customerGroupings.sortableGroups) {
      this.customerGroupings.customerGroups = _.orderBy(
        this.customerGroupings.customerGroups,
        ["sortOrder"],
        ["asc"]
      );
    } else {
      this.customerGroupings.customerGroups = _.sortBy(
        this.customerGroupings.customerGroups,
        [
          (group) => {
            return !group.isDefault;
          },
        ]
      );
    }
    this.sortCodes();
  }

  groupSelected(event) {
    let changedGroup = _.filter(this.customerGroupings.customerGroups, {
      id: event.id,
    })[0];
    changedGroup["results"] = event["results"];
    this.countCodesSelected();
  }

  countCodesSelected() {
    this.codesSelected = 0;
    _.forEach(this.customerGroupings.customerGroups, (group) => {
      let selectedResults = _.filter(group.results, { checked: true });
      this.codesSelected = this.codesSelected + selectedResults.length;
    });
  }

  moveSelectedCodes(targetGroupId) {
    let targetGroup = _.filter(this.customerGroupings.customerGroups, {
      id: targetGroupId,
    })[0];
    _.forEach(this.customerGroupings.customerGroups, (group: any) => {
      if (group["id"] !== targetGroupId) {
        // transfer any selected results to the new group
        let selectedResults = _.filter(group["results"], { checked: true });
        if (selectedResults.length > 0) {
          if (targetGroup["results"]) {
            targetGroup["results"] = targetGroup["results"].concat(
              selectedResults
            );
          } else {
            targetGroup["results"] = _.cloneDeep(selectedResults);
          }
          // remove any selected results from the old group
          group["results"] = _.cloneDeep(
            _.filter(group["results"], (result: any) => {
              return !result.checked;
            })
          );
          // remove "checked" property from all results in the group
          _.forEach(group["results"], (result: any) => {
            delete result.checked;
          });
          // if we don't have any more results, set this group to have null results instead of an empty array so when we
          // compare it with the original we won't have null != empty array issues
          if (group["results"].length == 0) {
            group["results"] = null;
          }
        }
        // clear the selectAll variable
        delete group["selectAll"];
      }
    });
    // remove "checked" property from all results in the targetGroup
    _.forEach(targetGroup["results"], (result: any) => {
      delete result.checked;
    });
    // re-alphabetize the codes in the target group list
    targetGroup["results"] = _.sortBy(targetGroup["results"], ["name"]);
    // now clear the codes selected variable
    this.codesSelected = null;
    // clear the selectAll variable
    delete targetGroup["selectAll"];
    // check if there are changes to be saved
    this.areChangesToBeSaved = this.checkForChangesToBeSaved();
    // remove any filters from the groups
    if (this.groups && this.groups.toArray().length > 0) {
      this.removeFiltersFromGroups();
    }
  }

  removeFiltersFromGroups() {
    _.forEach(this.groups.toArray(), (group: any) => {
      group.clearFilters();
    });
  }

  checkForChangesToBeSaved() {
    return !_.isEqual(
      this.originalCustomerGroupings.customerGroups,
      this.customerGroupings.customerGroups
    );
  }

  saveChanges() {
    this.saveInProgress = true;
    // for each customer group, modify the customerRuleSets array to contain the new rules based on the results
    _.forEach(this.customerGroupings.customerGroups, (group) => {
      // get rid of any id < 0 used for creating new groups, has to be null for the service to know it's a new group
      if (group.id < 0) {
        group.id = null;
      }
      // clear any existing customerRuleSets
      group.customerRuleSets = [];
      // for each result, add it as a customer rule set
      _.forEach(group.results, (result) => {
        let newRulesetObj = { logicalOperator: "AND", customerRules: [] };
        _.forEach(result.sourceColumns, (sourceColumn) => {
          newRulesetObj["customerRules"].push({
            key: sourceColumn.key,
            value: sourceColumn.value,
            comparator: "=",
          });
        });
        group.customerRuleSets.push(newRulesetObj);
      });
    });
    this.groupingService
      .replaceGroupsOfCustomerGrouping(
        this.customerGroupings.id,
        this.customerGroupings.customerGroups
      )
      .subscribe(
        (data) => {
          // we replace any groups that had no id with their current id
          // we can't just use the data that comes back because it doesn't come back with results
          this.replaceNullIdGroups(data);
          this.saveInProgress = false;
          this.saveError = false;
          this.areChangesToBeSaved = false;
          this.originalCustomerGroupings = _.cloneDeep(this.customerGroupings);
        },
        (error) => {
          this.saveInProgress = false;
          this.saveError = true;
          console.log(error);
        }
      );
  }

  replaceNullIdGroups(data) {
    let nullIdGroups = _.filter(this.customerGroupings.customerGroups, {
      id: null,
    });
    _.forEach(nullIdGroups, (nullIdGroup: any) => {
      nullIdGroup.id = _.filter(data.customerGroups, {
        name: nullIdGroup.name,
      })[0]["id"];
    });
  }

  isGradeLevelAtTheTime() {
    return (
      this.selectedDataConfig &&
      this.selectedDataConfig["aggregategroup_displayname"] &&
      this.selectedDataConfig["aggregategroup_displayname"] ==
        "Grade Level At The Time"
    );
  }

  getAggGroupName() {
    if (this.selectedDataConfig && this.selectedDataConfig.displayName) {
      return this.selectedDataConfig.displayName;
    } else if (
      this.selectedDataConfig &&
      this.selectedDataConfig.aggregategroup_displayname
    ) {
      return this.selectedDataConfig.aggregategroup_displayname;
    } else {
      return "this aggregate group";
    }
  }

  sortCodes() {
    _.forEach(this.customerGroupings.customerGroups, (group: any) => {
      if (group["results"] && group["results"].length > 0) {
        group["results"] = _.sortBy(group["results"], ["name"]);
      } else {
        group["results"] = null;
      }
    });
  }

  editGroup(groupData, isAddingNewCategory) {
    const dialogRef = this.dialog.open(EditGroupModalComponent, {
      data: {
        groupData: groupData,
        allGroups: this.customerGroupings.customerGroups,
        isAddingNewCategory: isAddingNewCategory,
      },
      width: "60rem",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.groupMetadataChanged(result);
      } else {
        if (
          _.filter(this.customerGroupings.customerGroups, { name: "" }).length >
          0
        ) {
          // if the user has closed the modal after adding a new group, but hasn't saved the name
          // then remove the empty group
          _.remove(this.customerGroupings.customerGroups, {
            name: "",
          });
        }
      }
    });
  }

  groupMetadataChanged(changeObj) {
    // now we'll filter for the group we're dealing with
    // if changeObj.categoryName != null, then we'll update the group's category name
    // if the group.isDefault != changeObj.isDefault, there are two cases
    // 1) the group was default before and now it's not. Then we'll also have to filter for the new group and make that default
    // 2) the group wasn't default before. Then we'll have to filter for the group that was default before (first step) and then make it not default
    let groupBeingEdited = _.filter(this.customerGroupings.customerGroups, {
      id: changeObj.categoryId,
      displayAlias: changeObj.previousDisplayAlias,
    })[0];

    if (changeObj.categoryName) {
      groupBeingEdited["name"] = changeObj.categoryName;
      groupBeingEdited["displayAlias"] = changeObj.categoryName;
    }
    if (changeObj.isDefault != groupBeingEdited["isDefault"]) {
      if (groupBeingEdited["isDefault"]) {
        // now the group being edited is not default
        groupBeingEdited["isDefault"] = false;
        // filter for the new group that should be default
        let newGroupToBeDefault = _.filter(
          this.customerGroupings.customerGroups,
          { id: changeObj.newDefaultCategoryId }
        )[0];
        newGroupToBeDefault["isDefault"] = true;
      } else {
        // filter for the previous default group
        let previousDefaultGroup = _.filter(
          this.customerGroupings.customerGroups,
          { isDefault: true }
        )[0];
        previousDefaultGroup["isDefault"] = false;
        // the group that's being edited is the default group now
        groupBeingEdited["isDefault"] = true;
      }
    }
    // check if there are changes to be saved
    this.areChangesToBeSaved = this.checkForChangesToBeSaved();
  }

  visibilityToggled(event) {
    this.dashboardDisplayService
      .addorUpdateCustAggGroup(
        this.selectedDataConfig["kpi_id"],
        this.selectedDataConfig["id"],
        this.selectedDataConfig["standard_aggregate_group_id"],
        this.selectedDataConfig["aggregategroup_tablename"],
        event.checked
      )
      .subscribe(
        (data) => {
          this.visibilityChanged.emit(data);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  newCategory() {
    // create placeholder new group id (can be multiple new groups)
    let newGroupId = this.getNewGroupId();
    let newCategoryObj = {
      customerId: this.customerGroupings.customerGroups[0].customerId,
      displayAlias: "",
      isDefault: false,
      isEditable: true,
      name: "",
      id: newGroupId,
      sortOrder: this.customerGroupings.sortableGroups
        ? this.customerGroupings.customerGroups.length > 0
          ? this.customerGroupings.customerGroups[
              this.customerGroupings.customerGroups.length - 1
            ].sortOrder + 1
          : 1
        : null,
    };
    this.customerGroupings.customerGroups.push(newCategoryObj);
    this.editGroup(newCategoryObj, true);
  }

  getNewGroupId() {
    // create new group ids -1, -2, -3, .. to allow for multiple new group creation
    let numNewGroups = _.filter(
      this.customerGroupings.customerGroups,
      (group) => {
        return group.id < 0;
      }
    );
    return numNewGroups.length > 0 ? numNewGroups.length * -1 - 1 : -1;
  }

  deleteGroup(group) {
    // we remove the group from the list and move all of the results to the default group
    let defaultGroup = _.filter(this.customerGroupings.customerGroups, {
      isDefault: true,
    })[0];
    if (defaultGroup["results"] && group.results) {
      defaultGroup["results"] = defaultGroup["results"].concat(group.results);
      // re-alphabetize
      defaultGroup["results"] = _.sortBy(defaultGroup["results"], ["name"]);
    } else if (!defaultGroup["results"] && group.results) {
      defaultGroup["results"] = group.results;
    }
    _.remove(this.customerGroupings.customerGroups, {
      id: group.id,
    });
    // check if there are changes to be saved
    this.areChangesToBeSaved = this.checkForChangesToBeSaved();
  }

  goToCurrentGradeLevel() {
    this.goToCurrentGradeLevelEmitter.emit();
  }

  showLeftArrow(group) {
    // don't show the left arrow for the first group
    return (
      this.customerGroupings.sortableGroups &&
      group.id != this.customerGroupings.customerGroups[0].id
    );
  }

  showRightArrow(group) {
    // don't show the right arrow for the last group
    return (
      this.customerGroupings.sortableGroups &&
      group.id !=
        this.customerGroupings.customerGroups[
          this.customerGroupings.customerGroups.length - 1
        ].id
    );
  }

  moveGroupLeft(group) {
    // we want to move this group to the left, so we want to find the group in the list of customerGroups,
    // and the group to its left, and then swap the orders of those two groups
    let groupToMove = _.filter(this.customerGroupings.customerGroups, {
      sortOrder: group.sortOrder,
    })[0];
    let groupToMoveIndex = _.findIndex(this.customerGroupings.customerGroups, [
      "sortOrder",
      group.sortOrder,
    ]);
    let neighbourGroup = this.customerGroupings.customerGroups[
      groupToMoveIndex - 1
    ];
    this.swapSortOrders(groupToMove, neighbourGroup);
    // check if there are changes to be saved
    this.areChangesToBeSaved = this.checkForChangesToBeSaved();
  }

  moveGroupRight(group) {
    let groupToMove = _.filter(this.customerGroupings.customerGroups, {
      sortOrder: group.sortOrder,
    })[0];
    let groupToMoveIndex = _.findIndex(this.customerGroupings.customerGroups, [
      "sortOrder",
      group.sortOrder,
    ]);
    let neighbourGroup = this.customerGroupings.customerGroups[
      groupToMoveIndex + 1
    ];
    this.swapSortOrders(groupToMove, neighbourGroup);
    // check if there are changes to be saved
    this.areChangesToBeSaved = this.checkForChangesToBeSaved();
  }

  swapSortOrders(groupToMove, neighbourGroup) {
    let newNeighbourSortOrder = groupToMove.sortOrder;
    groupToMove.sortOrder = neighbourGroup.sortOrder;
    neighbourGroup.sortOrder = newNeighbourSortOrder;
    this.customerGroupings.customerGroups = _.orderBy(
      this.customerGroupings.customerGroups,
      ["sortOrder"],
      ["asc"]
    );
  }
}
